module.exports = __webpack_public_path__ + "img/podcast.cba149d4.svg";